module.exports = __webpack_public_path__ + "static/img/interface.69343003.png";